module.exports = __webpack_public_path__ + "img/parking_logo.86b8a04e.png";